import { useTranslation } from 'react-i18next'

import pageLanguage from '../../functions/pageLanguage'
import { useScroll } from '../../functions/useScroll'
import RefinedBrands from '../Brands/RefinedBrands'
import Colors from '../Colors/Colors'
import CustomClearRefinements from '../CurrentRefinement/ClearRefinements'
import CustomSortBy from '../DesktopSort/CustomSortBy'
import RefinedCategories from '../DeviceCategories/RefinedCategories'
import CustomInfiniteHits from '../InfiniteHits/InfiniteHits'
import Price from '../Price/Price'

import './DesktopComponent.scss'

const DesktopComponent = (currentRefinement: any) => {
  const { t } = useTranslation()
  const lang = pageLanguage()
  const { scrollY } = useScroll();
  const categoryAttribute = lang === "ar" ? "category.deviceSubType.valueAr" : "category.deviceSubType.valueEn"
  const brandAttribute = lang === "ar" ? "category.brand.valueAr" : "category.brand.valueEn"
  const colorTextAttribute = "category.colorCode.filter"

  return (
    <div className="container">
      <div className="top-panel">
        <div className={scrollY > 100.00 ? "hideTitle" : "devicesTitle"}>
          {t('devices')}
        </div>
        <RefinedCategories attribute={categoryAttribute} facetOrdering={true} defaultRefinement={[t('SmartPhones')]}
        />
      </div>
      <div className={`filters-and-devices ${scrollY > 100 ? 'scrollClass' : ''}`}>
        <CustomSortBy />
        <div className="left-and-right-panel">
          <div className="left-panel" id="left-panel">
            <div className="left-header">
              <span className="filter">{t('filter')}</span>
              <span className="reset">
                <CustomClearRefinements clearsQuery />
              </span>
            </div>
            <Price />
            <RefinedBrands attribute={brandAttribute} />
            <Colors attribute={colorTextAttribute} limit={50} />
          </div>
          <div className='gap' />
          <div className="right-panel">
            {currentRefinement !== '' ? (
              <div className='devices__content'>
                <CustomInfiniteHits />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopComponent
